import { Action } from '@ngrx/store'
import * as SmtpSettingsTypes from './smtp-settings.types'

export class FetchSmtpSettingsRequest implements Action {
  readonly type = SmtpSettingsTypes.FETCH_SMTP_SETTINGS_REQUEST
  constructor() {}
}

export class FetchSmtpSettingsSuccess implements Action {
  readonly type = SmtpSettingsTypes.FETCH_SMTP_SETTINGS_SUCCESS
  constructor(public payload: any) {}
}

export class FetchSmtpSettingsFailure implements Action {
  readonly type = SmtpSettingsTypes.FETCH_SMTP_SETTINGS_FAILURE
  constructor(public payload: any) {}
}

export class UpdateSmtpSettingsRequest implements Action {
  readonly type = SmtpSettingsTypes.UPDATE_SMTP_SETTINGS_REQUEST
  constructor(public payload: any) {}
}

export class UpdateSmtpSettingsSuccess implements Action {
  readonly type = SmtpSettingsTypes.UPDATE_SMTP_SETTINGS_SUCCESS
  constructor() {}
}

export class UpdateSmtpSettingsFailure implements Action {
  readonly type = SmtpSettingsTypes.UPDATE_SMTP_SETTINGS_FAILURE
  constructor(public payload: any) {}
}

export class UpdateField implements Action {
  readonly type = SmtpSettingsTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = SmtpSettingsTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | FetchSmtpSettingsSuccess
  | FetchSmtpSettingsFailure
  | FetchSmtpSettingsRequest
  | UpdateSmtpSettingsRequest
  | UpdateSmtpSettingsSuccess
  | UpdateSmtpSettingsFailure
  | SetDefaultData
  | UpdateField
